let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iKYLW")).then(() => parcelRequire('4kZpc'));